import Hourglass from '@/images/Hourglass.svg';
import { ttsVoiceAgeFilter } from '@/state/presenters';
import { AGE } from '@d-id/tts/types';
import { SelectChangeEvent } from '@mui/material/Select';
import { memo, useCallback, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import { FilterChipSelect, FilterOption } from './FilterChipSelect';

const defaultOption = { value: 'all', label: 'All', chipLabel: 'Age', icon: Hourglass, skipListIcon: true };

const ageOptions: FilterOption[] = [
    defaultOption,
    { value: AGE.YOUNG, label: 'Young' },
    { value: AGE.ADULT, label: 'Adult' },
    { value: AGE.OLDER, label: 'Older' },
];

export const AgeChipSelect = memo(() => {
    const [ttsVoiceAgeFilterValue, setTtsVoiceAgeFilter] = useRecoilState(ttsVoiceAgeFilter);

    const handleChange = useCallback((e: SelectChangeEvent<string>) => {
        const value = (ageOptions.find(o => o.value === e.target.value)?.value as AGE) || defaultOption.value;

        setTtsVoiceAgeFilter(value);
    }, []);

    const option = useMemo(
        () => ageOptions.find(option => option.value === ttsVoiceAgeFilterValue) || defaultOption,
        [ttsVoiceAgeFilterValue]
    );

    return (
        <FilterChipSelect
            data-testid="voice-age-filter"
            id="age-filter"
            variant="outlined"
            value={option}
            options={ageOptions}
            onChange={handleChange}
        />
    );
});
